export default __webpack_public_path__ + "static/avatar-kayi-common-9-d5a341e3c18099f3d9d7f0c582fac07c.png";